import React, { useRef, useState } from "react";
import Address from "./Address";
import PaymentSuccess from "./Paymentsuccess";
import PaymentFailed from "./PaymentFailed";
import decryptCookieData from "./Functions/decryptCookieData";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getDistance } from "geolib";
import getCoordinatesFromAddress from "./utils/geocodeAddress";
import { useNavigate } from "react-router-dom";

const Checkout = ({ paybutton, user }) => {
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [email, setEmail] = useState("");
  const userData =
    JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || null;
  const phonenumber = userData?.mobile || "";
  const [mobile, setMobile] = useState(phonenumber);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("Pay now");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [freeDeliveryRules, setFreeDeliveryRules] = useState([]);
  const [razorpay, setRazorpay] = useState({});
  const [gstNumber, setGstNumber] = useState("");
  const [customerNote, setCustomerNote] = useState("");
  const contactRef = useRef();
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [validationError, setValidationError] = useState("");
  const [vendorAddress, setVendorAddress] = useState("");
  const [deliveryRules, setDeliveryRules] = useState([]);
  const [distanceInKm, setDistanceInKm] = useState(null);
  const [pincodes, setPincodes] = useState([]);
  const admissioncheck = JSON.parse(localStorage.getItem("admission")) || "";
  const [gstPercent, setGstPercent] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const [gstTotalMinimum, setTotalMinimum] = useState(0);

  const navigate = useNavigate();

  const [checkoutInfo, setCheckoutInfo] = useState(null);
  const url = process.env.REACT_APP_API_URL;

  const fetchPincodeData = async () => {
    try {
      const response = await fetch(
        `${url}/pincode/getall/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();
      setPincodes(res.pincodesData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("checkout_data"));
    setCheckoutInfo(data);
  }, []);

  const [data, setData] = useState({
    location_user: "",
    new_address: "",
    city: "",
    pincode: "",
    user_id: userData.user_id,
    user_name: userData.full_name,
    main_id: process.env.REACT_APP_PERFUME_ID,
    number: mobile,
    area: "",
  });
  const [formData, setFormData] = useState(null);

  const razorpayIdFetch = async () => {
    try {
      const response = await fetch(
        `${url}/pay-razorpay/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();
      if (response.ok) {
        setRazorpay(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (checkoutInfo && selectedBillingAddress && selectedShippingAddress) {
      const totalAmount = checkoutInfo.totalAfterDiscount || 0;
      const deliveryCharge = calculateDeliveryCharge();
      // console.log(deliveryCharge)
      // add this just before setFormData
      let upfrontAmount = totalAmount;
      let remainingPrice = 0;

      if (selectedPayment === "Pay on delivery" && percentage > 0) {
        upfrontAmount = Math.round((totalAmount * percentage) / 100);
        remainingPrice = totalAmount - upfrontAmount;
      }

      const calculatedGst = (upfrontAmount * gstPercent) / 100;
      setGstAmount(calculatedGst);

      const paymentAdavnce = Number(upfrontAmount);
      setAdvanceAmount(paymentAdavnce);
      setFormData({
        user_id: userData?.user_id,
        order_id: "",
        payment_capture: "",
        currency: "",
        user_name: userData?.full_name,
        amountbeforediscount: checkoutInfo.totalBeforeDiscount,
        amountafterdiscount:
          Number(upfrontAmount) +
          Number(deliveryCharge || 0) +
          Number(calculatedGst),
        deliveryCharge: deliveryCharge,
        user_gstNo: gstNumber,
        customer_note: customerNote,
        remaining_amount: remainingPrice,
        cart_products: checkoutInfo.products,
        couponapplied: checkoutInfo.isCouponApplied,
        coupon_code: checkoutInfo.coupon,
        discountprice: checkoutInfo.discountAmount,
        delivery_date: checkoutInfo.deliveryDate,
        billing_address: selectedBillingAddress,
        shipping_address: selectedShippingAddress,
        payment_mode: selectedPayment,
        totalAmountbeforePay:
          Number(checkoutInfo.totalAfterDiscount) + Number(deliveryCharge || 0),
        main_id: process.env.REACT_APP_PERFUME_ID,
        order_id: admissioncheck ? admissioncheck.payment_id : "",
        mobile: mobile,
        email: userData.email,
      });
    }
  }, [
    checkoutInfo,
    selectedBillingAddress,
    selectedShippingAddress,
    percentage,
    vendorAddress,
    deliveryRules,
    selectedPayment,
    gstPercent,
  ]);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const selectPayment = (option) => {
    setSelectedPayment(option);
    setShowOptions(false); // Close options after selection
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${url}/registeruser/single/${userData.user_id}`,
      );
      const res = await response.json();
      setMobile(res.mobile);
      setGstNumber(res.user_gstNo || "");
    } catch (error) {
      console.error(error);
    }
  };

  const submitMobile = async () => {
    setIsEditingContact(false);
    try {
      const response = await fetch(
        `${url}/registeruser/api/user/${userData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ mobile, user_gstNo: gstNumber }),
        },
      );
      const res = await response.json();
      if (res.success) {
        await fetchData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const placeOrder = async () => {
    if (!selectedBillingAddress) {
      setValidationError("Please select a billing address.");
      toast.error("Address not found");
      return;
    }

    if (!selectedShippingAddress) {
      setValidationError("Please select a shipping address.");
      toast.error("Address not found");
      return;
    }

    if (!mobile || mobile?.length !== 10) {
      setIsEditingContact(true);
      setValidationError("Please enter a valid 10-digit mobile number.");
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (selectedPayment === "Select pay") {
      setValidationError("Please select a payment method.");
      toast.error("Please select a payment method.");
      return;
    }

    formData.key_id = razorpay?.key_id;
    formData.key_secret = razorpay?.key_secret;

    const activePincodeList = pincodes
      .filter((p) => p.status === "Active")
      .map((p) => p.pincode?.toString());
    if (
      activePincodeList.length > 0 &&
      !activePincodeList.includes(selectedShippingAddress?.pincode?.toString())
    ) {
      setValidationError("Delivery is not available to this pincode.");
      toast.error("Sorry, we do not deliver to this pincode.");
      return;
    }

    setValidationError("");
    const apiBase = admissioncheck ? `${url}/admission-pay` : `${url}/payment`;
    if (selectedPayment === "Pay on delivery" && percentage === 0) {
      try {
        const response = await fetch(`${apiBase}/paydelivery`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const result = await response.json();
        if (result.success) {
          navigate(`/payment-success/${result.order_id}`);
        } else {
          toast.error("Failed to create Razorpay order");
        }
      } catch (err) {
        console.error("Error placing order:", err);
        toast.error("Error during checkout");
      }
    } else {
      try {
        const response = await fetch(`${apiBase}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });

        const result = await response.json();
        if (result.success) {
          openRazorpay(
            result.razorpay_order,
            result.order_id,
            razorpay.key_id,
            result.receipt_id,
          );
        } else {
          toast.error("Failed to create Razorpay order");
        }
      } catch (err) {
        console.error("Error placing order:", err);
        toast.error("Error during checkout");
      }
    }
  };

  const openRazorpay = (razorpayOrder, order_id, rzkey, receipt_id) => {
    const apiBase = admissioncheck ? `${url}/admission-pay` : `${url}/payment`;
    const options = {
      key: `${razorpay.key_id}`,
      amount: razorpayOrder.amount,
      currency: razorpayOrder.currency,
      name: `${razorpay.company_name}`,
      description: "Order Payment",
      order_id: razorpayOrder.id,
      handler: async function (response) {
        const verifyRes = await fetch(`${apiBase}/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            key_id: razorpay.key_secret,
            receipt_id: receipt_id,
          }),
        });

        const verifyData = await verifyRes.json();
        if (admissioncheck) {
          if (verifyData.success) {
            window.location.href = `/payment-successad/${receipt_id}`; // ✅ Redirect on success
            localStorage.removeItem("admission");
          } else {
            window.location.href = `/payment-failedad/${receipt_id}`;
          }
        } else {
          if (verifyData.success) {
            window.location.href = `/payment-success/${order_id}`; // ✅ Redirect on success
            localStorage.removeItem("admission");
          } else {
            window.location.href = `/payment-failed/${order_id}`; // ❌ Redirect on failure
          }
        }
      },
      prefill: {
        name: user?.full_name,
        email: user?.email,
        contact: mobile,
      },
      theme: { color: `${razorpay.company_color}` },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  // console.log(selectedShippingAddress)
  const calculateDeliveryCharge = () => {
    if (
      !selectedShippingAddress ||
      !vendorAddress ||
      !deliveryRules.length ||
      !vendorAddress?.latitude ||
      !vendorAddress?.longitude ||
      !selectedShippingAddress.latitude ||
      !selectedShippingAddress.longitude
    ) {
      return 0;
    }

    const distanceMeters = getDistance(
      {
        latitude: parseFloat(vendorAddress?.latitude),
        longitude: parseFloat(vendorAddress?.longitude),
      },
      {
        latitude: parseFloat(selectedShippingAddress?.latitude),
        longitude: parseFloat(selectedShippingAddress?.longitude),
      },
    );

    const distanceKm = distanceMeters / 1000;
    let roundedDistance;

    if (distanceKm > 0.1 && distanceKm < 1) {
      roundedDistance = 1;
    } else {
      roundedDistance = Math.round(distanceKm);
    }
    setDistanceInKm(roundedDistance);

    const cartTotal = checkoutInfo?.totalAfterDiscount || 0;

    // console.log(distanceInKm)
    const freeRule = freeDeliveryRules.find(
      (rule) =>
        distanceKm >= rule.min_kilometer &&
        distanceKm <= rule.max_kilometer &&
        cartTotal >= rule.freedelivery_price,
    );
    if (freeRule) {
      return 0;
    }

    const matchedRule = deliveryRules.find(
      (rule) =>
        distanceKm >= rule.min_kilometer &&
        distanceKm <= rule.max_kilometer &&
        rule.status === "Active",
    );

    return matchedRule?.delivery_price || 0;
  };

  const fetchDeliveryPayData = async () => {
    try {
      const response = await fetch(
        `${url}/deliverypaybefore/single/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();
      if (res?.help?.delivery_percentage) {
        setPercentage(Number(res.help.delivery_percentage));
      } else {
        setPercentage(0);
      }
    } catch (error) {
      console.error("Error fetching delivery data:", error);
      setPercentage(0);
    }
  };

  const fetchDelivery = async () => {
    try {
      const response = await fetch(
        `${url}/delivery-price/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();
      setDeliveryRules(res.data || []);
    } catch (error) {
      console.error("Delivery price fetch error:", error);
      setDeliveryRules([]);
    }
  };

  const fetchDataAddressAdmin = async () => {
    try {
      const response = await fetch(
        `${url}/register/officeuserget/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();

      if (typeof res.google_address === "string") {
        const coords = await getCoordinatesFromAddress(res.google_address);
        if (coords) {
          setVendorAddress({
            ...coords,
            address: res.office_address,
          });
        }
      } else {
        setVendorAddress(res.office_address);
      }
    } catch (error) {
      console.error("Error fetching vendor address:", error);
    }
  };

  useEffect(() => {
    const fetchCoordinatesForAddresses = async () => {
      // Only geocode if distance is needed and not already present
      if (
        (!vendorAddress?.latitude || !vendorAddress?.longitude) &&
        typeof vendorAddress === "string"
      ) {
        const coords = await getCoordinatesFromAddress(vendorAddress);
        if (coords) {
          setVendorAddress((prev) => ({
            ...coords, // add latitude, longitude
            raw: vendorAddress, // optionally keep raw string
          }));
        }
      }

      if (
        selectedShippingAddress &&
        (!selectedShippingAddress.latitude ||
          !selectedShippingAddress.longitude)
      ) {
        const coords = await getCoordinatesFromAddress(
          selectedShippingAddress.area,
        );

        if (coords) {
          setSelectedShippingAddress((prev) => ({
            ...prev,
            latitude: coords.latitude,
            longitude: coords.longitude,
          }));
        }
      }
    };

    fetchCoordinatesForAddresses();
  }, [vendorAddress, selectedShippingAddress]);

  const deliveryCheckfree = async () => {
    try {
      const response = await fetch(
        `${url}/freedelivery/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const res = await response.json();
      if (Array.isArray(res.data)) {
        setFreeDeliveryRules(res.data);
      }
    } catch (error) {
      console.error(error);
      setFreeDeliveryRules([]);
    }
  };

  const fetchGst = async () => {
    try {
      const response = await fetch(
        `${url}/gst/${process.env.REACT_APP_PERFUME_ID}`,
      );
      const result = await response.json();
      if (response.ok && result.gstPercent) {
        setGstPercent(Number(result.gstPercent));
      }
    } catch (error) {
      console.log("Error fetching GST:", error);
    }
  };

  useEffect(() => {
    razorpayIdFetch();
    fetchData();
    fetchGst();
    fetchDeliveryPayData();
    fetchDelivery();
    fetchDataAddressAdmin();
    deliveryCheckfree();
    fetchPincodeData();
  }, []);

  // const getDefaultCartButton = () => {
  //     const isGetQuoteDefault = paybutton.find(b => b.button_id === 'paymanual' && b.default);
  //     if (isGetQuoteDefault) return 'paymanual';

  //     const isAddToCartDefault = paybutton.find(b => b.button_id === 'paynow' && b.default);
  //     if (isAddToCartDefault) return 'paynow';

  //     const isBuyNowDefault = paybutton.find(b => b.button_id === 'payondelivery' && b.default);
  //     if (isBuyNowDefault) return 'payondelivery';

  //     return null; // fallback
  // };
  const getDefaultCartButton = () => {
    const hasPayNow = paybutton.some((b) => b.button_id === "paynow");
    const hasPayOnDelivery = paybutton.some(
      (b) => b.button_id === "payondelivery",
    );

    if (hasPayNow && hasPayOnDelivery) return "both";
    if (hasPayNow) return "paynow";
    if (hasPayOnDelivery) return "payondelivery";
    return null;
  };

  const defaultButtonPay = getDefaultCartButton();

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="checkout-perfume">
        <div className="cart-columns-perfume">
          <div className="address-container cart-column1-perfume">
            <Address
              data={data}
              setData={setData}
              selectedBillingAddress={selectedBillingAddress}
              setSelectedShippingAddress={setSelectedShippingAddress}
              setSelectedBillingAddress={setSelectedBillingAddress}
              selectedShippingAddress={selectedShippingAddress}
            />
            <div ref={contactRef} className="contact-info-section">
              {/* <h3>Contact Information</h3> */}

              {isEditingContact ? (
                <div className="contact-fields">
                  <div className="field-group">
                    <label>Email</label>
                    <input type="email" value={userData.email} disabled />
                  </div>

                  <div className="field-group">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      value={mobile}
                      onChange={(e) => {
                        let input = e.target.value.replace(/\s|-/g, "");
                        if (input.startsWith("+91")) input = input.slice(3);
                        else if (input.startsWith("91") && input.length > 10)
                          input = input.slice(2);
                        else if (input.startsWith("0")) input = input.slice(1);

                        input = input.replace(/\D/g, "");
                        if (input.length > 10) input = input.slice(0, 10);

                        setMobile(input);
                      }}
                      placeholder="Enter 10-digit mobile number"
                    />
                    {mobile?.length !== 10 && (
                      <p className="mobile-error">
                        Please enter a valid 10-digit mobile number.
                      </p>
                    )}
                  </div>

                  <div className="field-group">
                    <label>GST Number (optional)</label>
                    <input
                      type="text"
                      value={gstNumber}
                      onChange={(e) => setGstNumber(e.target.value)}
                      placeholder="Enter GST number (if any)"
                    />
                  </div>

                  <div className="field-group">
                    <label>Customer Note</label>
                    <input
                      type="text"
                      value={customerNote}
                      onChange={(e) => setCustomerNote(e.target.value)}
                      placeholder="Add any special instructions or notes"
                    />
                  </div>

                  <button
                    className="save-contact-btn"
                    onClick={submitMobile}
                    disabled={mobile?.length !== 10}
                  >
                    Save
                  </button>
                </div>
              ) : (
                <div className="contact-display">
                  <p>
                    <strong>Email:</strong> {userData.email}
                  </p>
                  <p>
                    <strong>Mobile:</strong> {mobile || "Not provided"}
                  </p>
                  <p>
                    <strong>GST Number:</strong> {gstNumber || "Not provided"}
                  </p>
                  <p>
                    <strong>Customer Note:</strong>{" "}
                    {customerNote || "Not provided"}
                  </p>
                  <button
                    className="save-contact-btn"
                    onClick={() => setIsEditingContact(true)}
                  >
                    Change
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="cart-column2-perfume">
            <div className="cart-column2-header-perfume">
              <h3>Order Summary</h3>
            </div>
            <div className="cart-column2-total-perfume">
              <div className="cart-total-labels">
                <p>
                  <strong>Sub Total</strong>
                </p>
                <p>Original Price</p>
                <p>Delivery Charge</p>
                {gstPercent && <p>Gst Tax ({gstPercent}%)</p>}

                {percentage > 0 && selectedPayment === "Pay on delivery" && (
                  <p>Advance Payable</p>
                )}
                <p>
                  <strong>Grand Total</strong>
                </p>
                <p>
                  <strong>Delivery Date</strong>
                </p>
              </div>

              <div className="cart-total-value">
                <p>
                  <strong>₹{checkoutInfo?.totalAfterDiscount}</strong>
                </p>
                <p style={{ textDecoration: "line-through" }}>
                  ₹{checkoutInfo?.totalBeforeDiscount}
                </p>
                <p>₹{formData?.deliveryCharge || 0}</p>
                {gstPercent && <p>₹{gstAmount}</p>}

                {percentage > 0 && selectedPayment === "Pay on delivery" && (
                  <p>₹{advanceAmount}</p>
                )}
                <p>
                  ₹
                  {Number(checkoutInfo?.totalAfterDiscount) + Number(gstAmount)}
                </p>
                <p>
                  {checkoutInfo?.deliveryDate
                    ? new Date(checkoutInfo.deliveryDate).toLocaleDateString(
                        "en-IN",
                      )
                    : "Not selected"}
                </p>
              </div>
            </div>

            <div className="payment-container">
              <div className="payment-text" onClick={toggleOptions}>
                <div>Pay using</div>
                <div>
                  {selectedPayment} <i class="fa-solid fa-angle-down"></i>
                </div>
              </div>

              {showOptions && (
                <div className="payment-options">
                  {paybutton.some(
                    (b) => b.button_id === "payondelivery" && b.default,
                  ) && (
                    <div onClick={() => selectPayment("Pay on delivery")}>
                      Pay on delivery
                    </div>
                  )}
                  {paybutton.some(
                    (b) => b.button_id === "paynow" && b.default,
                  ) && (
                    <div onClick={() => selectPayment("Pay now")}>Pay now</div>
                  )}
                </div>
              )}

              <button className="payment-button" onClick={placeOrder}>
                Place order
              </button>
            </div>
            {percentage > 0 && selectedPayment === "Pay on delivery" && (
              <div
                className="delivery-pay-note"
                style={{
                  marginTop: "10px",
                  color: "#d9534f",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: "15px",
                }}
              >
                You need to pay {percentage}% now online.
              </div>
            )}
          </div>
        </div>
      </div>

      {showSuccessModal && (
        <PaymentFailed onClose={() => setShowSuccessModal(false)} />
      )}
    </>
  );
};

export default Checkout;
